module.exports = __webpack_public_path__ + "img/img16.bbdf9b53.jpg";